module.exports = __webpack_public_path__ + "static/media/gow.eafe2ed1.svg";